var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15a.5.5 0 01.5.5v.5h7a1 1 0 010 2h-7v.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V18H4a1 1 0 010-2h7v-.5a.5.5 0 01.5-.5h1zm5-5a.5.5 0 01.5.5v.5h2a1 1 0 010 2h-2v.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H4a1 1 0 010-2h12v-.5a.5.5 0 01.5-.5h1zm-10-5a.5.5 0 01.5.5V6h12a1 1 0 010 2H8v.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V8H4a1 1 0 110-2h2v-.5a.5.5 0 01.5-.5h1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSettings);
export default __webpack_public_path__ + "static/media/filterSettings.0deb3639.svg";
export { ForwardRef as ReactComponent };